import { render, staticRenderFns } from "./GuaranteesListTable.vue?vue&type=template&id=5d2d7cb6&scoped=true&"
import script from "./GuaranteesListTable.vue?vue&type=script&lang=js&"
export * from "./GuaranteesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d7cb6",
  null
  
)

export default component.exports